export class RequisitionSkill {
    id: any;
    title: any = '';
    degreeName: any = '';
    fieldOfStudy: any = '';
    minExperienceInMonths: any = '';
    range: '';
    plusTo: any = '';
    maxExperienceInMonths: any = '';
    competency: any = '';
    mandatory: boolean = true;
    favorite: boolean = false;
    niceToHave: boolean = false;
    preferred: boolean = false;
    priority: boolean = false;
    displayName: "";
    jdActionWord: "";
    constructor(text) {
        this.degreeName = text;
    }
}